function validateEntireSubpageTheme(subpageClass) {
  return $("body").hasClass(subpageClass);
}

function validateLandingPage(homeClass) {
  return $("body").hasClass(homeClass);
}

function validateSubPage(homeClass, subpageClass) {
  return $("body").hasClass(subpageClass) && !$("body").hasClass(homeClass);
}

const storage = window.sessionStorage;
let location = window.location.pathname;

function applyThemeClass(theme) {
  storage.setItem("subPage", true);
  storage.setItem("subpageName", theme);
}

function addSubThemeToSaffirePages() {
  if (
    !location.includes(themesConfig[0].navItemUrl) &&
    !location.includes(themesConfig[1].navItemUrl) &&
    !location.includes(themesConfig[2].navItemUrl) &&
    !location.includes(themesConfig[3].navItemUrl)
  ) {
    $("body").addClass(storage.getItem("subpageName"));
  }
}

function createBurgerTogle(theme) {
  const currentToggle = $(`.mobile-nav-toggle`);
  for (let i = 0; i < 3; i++) {
    currentToggle.append("<span class='bg-line'></span>");
  }
}

function customizeSearchBar(themeHeading, inputElement, textPlaceholder) {
  $(`.${themeHeading} .${inputElement} input`).attr(
    "placeholder",
    `${textPlaceholder}`
  );
  $(`.${themeHeading} .${inputElement} input`).val("");
}

function removeOldHeader(themeHeading) {
  $(`.${themeHeading} .headerInnerContent`).remove();
}

function customWeatherWidget() {
  setInterval(function () {
    let str = $("#weatherBugDescription").text();
    let weatherBugSet = $("#weatherBugWidget").hasClass("weatherBugSet");
    if (weatherBugSet || str == "") return;
    $("#weatherBugWidget").addClass("weatherBugSet");
    let findSpace = str.lastIndexOf(" ");
    let stringLength = str.length;
    let res = str.substring(findSpace, stringLength);
    let start = str.substring(0, findSpace);
    $("#weatherBugDescription").html(
      '<span class="weatherDescriptive">' + start + "</span>" + res
    );
    $("#weatherBugWidget").css("opacity", 1);
  }, 1000);
}

function showContent(themeClass) {
  setTimeout(() => {
    $(`.${themeClass}`).css("opacity", 1);
  }, 1000);
}

function checkWindowsSize(pixels) {
  return $(window).width() <= pixels;
}

function isLocalUrl(urlToCheck) {
  const clientPath = SITEBASEURL;
  return urlToCheck !== null && urlToCheck.includes(clientPath);
}

function validateVideoStatus(videoId, placeholderId) {
  const video = document.getElementById(videoId);

  video.play().catch((error) => {
    console.error("Error trying to play video:", error);
  });

  setTimeout(() => {
    const isPlaying = video.readyState >= 3 && !video.paused && !video.ended;

    if (isPlaying) {
      $(`#${placeholderId}`).css("opacity", "0");
      $(`#${videoId}`).css("opacity", "1");
    }
  }, 3000);
}

export {
  validateEntireSubpageTheme,
  validateLandingPage,
  validateSubPage,
  applyThemeClass,
  addSubThemeToSaffirePages,
  storage,
  isLocalUrl,
  createBurgerTogle,
  customizeSearchBar,
  removeOldHeader,
  customWeatherWidget,
  showContent,
  checkWindowsSize,
  validateVideoStatus,
};
